import ImageContainer from './containers/ImageContainer'

// Sync route definition
export default {
  path      : '/jobs/:jobId/images',
  component : ImageContainer
}



// WEBPACK FOOTER //
// ./src/routes/Images/index.js